export const experience = [
  {
    "title": "Full-Stack Engineer",
    "company": "Spotawheel",
    "startDate": "05/2022",
    "endDate": "Currently",
    "skills": {
      "title": "Skills",
      "list": [
        { "content": "Laravel" },
        { "content": "PostgreSQL" },
        { "content": "Vue.js" },
        { "content": "Ionic Framework" },
        { "content": "SCSS (Sass)" },
        { "content": "Git Version Control" },
        { "content": "OpenAI APIs" }
      ]
    }
  },
  {
    "title": "Senior Front-End Engineer",
    "company": "Empist",
    "startDate": "12/2018",
    "endDate": "04/2022",
    "skills": {
      "title": "Skills",
      "list": [
        { "content": "Vue.js" },
        { "content": "REST APIs" },
        { "content": "Vanilla JavaScript" },
        { "content": "SCSS (Sass)" },
        { "content": "HTML5 Best Practices" },
        { "content": "Accessibility & SEO Best Practices" },
        { "content": "Shopify & WordPress (Custom Theming)" }
      ]
    }
  },
  {
    "title": "Mid/Senior Front-End Engineer",
    "company": "ClickMedia",
    "startDate": "10/2016",
    "endDate": "11/2018",
    "skills": {
      "title": "Skills",
      "list": [
        { "content": "Vanilla JavaScript" },
        { "content": "jQuery" },
        { "content": "CSS3 & CSS Animations" },
        { "content": "WordPress (Custom Theming)" },
        { "content": "Joomla (Custom Theming)" }
      ]
    }
  },
  {
    "title": "Front-End Engineer",
    "company": "Freelance",
    "startDate": "04/2016",
    "endDate": "10/2016",
    "skills": {
      "title": "Skills",
      "list": [
        { "content": "Vanilla PHP" },
        { "content": "JavaScript" },
        { "content": "jQuery" },
        { "content": "SCSS (Sass)" },
        { "content": "MySQL" },
        { "content": "Joomla (Custom Theming)" }
      ]
    }
  },
  {
    "title": "Junior Front-End Developer",
    "company": "iMode",
    "startDate": "10/2015",
    "endDate": "04/2016",
    "skills": {
      "title": "Skills",
      "list": [
        { "content": "jQuery" },
        { "content": "Joomla (Custom Theming)" },
        { "content": "Email Templating (Mailchimp)" },
        { "content": "Customer Training" }
      ]
    }
  },
  {
    "title": "Entry-level Front-End Developer",
    "company": "Netikon",
    "startDate": "10/2014",
    "endDate": "06/2015",
    "skills": {
      "title": "Skills",
      "list": [
        { "content": "jQuery" },
        { "content": "Joomla (Custom Theming)" },
        { "content": "Custom HTML Sites" },
        { "content": "Site Maintenance" }
      ]
    }
  },
  {
    "title": "Private Lessons (German Language & AEP)",
    "company": "Freelance",
    "startDate": "09/2013",
    "endDate": "06/2014",
    "skills": {
      "title": "Skills",
      "list": [
        { "content": "Taught AEP and German Language lessons to high school and lyceum students." }
      ]
    }
  }
];
